export default {
  SET_PARTNER_DATA: '@AUTH_GATEWAY/PARTNER/SET_PARTNER_DATA',
};
